import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { CheckCircle2, Download, Eye, FolderOpen, PenLine, ScrollText } from 'lucide-react';
import { SignerReglementDialog, ouvrirPdf } from '../reglement-interieur/SignerReglementDialog';

const dateFr = (iso) => new Date(iso).toLocaleDateString('fr-FR');
const BTN = 'inline-flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-xs font-semibold transition-colors';

const Tuile = ({ Icone, titre, texte, ton, children, testId }) => (
  <div className={`flex flex-col gap-3 rounded-xl border p-4 ${ton}`} data-testid={testId}>
    <div className="flex items-start gap-3">
      <div className="rounded-lg bg-white/70 p-2"><Icone className="h-5 w-5" /></div>
      <div className="flex-1">
        <p className="font-semibold">{titre}</p>
        <p className="text-xs opacity-80">{texte}</p>
      </div>
    </div>
    <div className="flex flex-wrap gap-2">{children}</div>
  </div>
);

// Espace stagiaire : règlement intérieur (consultable, à signer, signé)
export const DocumentsAccueil = ({ user }) => {
  const [r, setR] = useState(null);
  const [ouvert, setOuvert] = useState(false);
  const charger = useCallback(() => { axios.get('/reglement-interieur/moi').then(({ data }) => setR(data)).catch(() => setR(null)); }, []);
  useEffect(() => {
    charger();
  }, [charger]);

  const statut = r?.statut || 'non_envoye';
  const aSigner = statut === 'a_signer';
  const signe = statut === 'signe';
  const consulter = (
    <button type="button" onClick={() => ouvrirPdf('/reglement-interieur/pdf', 'Reglement_interieur_FISL.pdf')} data-testid="docs-reglement-consulter"
      className={`${BTN} bg-white ring-1 ring-current/20 hover:bg-white/60`}><Eye className="h-3.5 w-3.5" /> Consulter</button>
  );

  return (
    <section data-testid="documents-accueil">
      <h2 className="mb-3 flex items-center gap-2 text-lg font-bold text-slate-800"><FolderOpen className="h-5 w-5 text-[#8DC63F]" /> Mes documents d'accueil</h2>
      <div className="grid gap-4">
        <Tuile Icone={signe ? CheckCircle2 : ScrollText} titre="Règlement intérieur" testId="docs-reglement"
          ton={signe ? 'border-emerald-200 bg-emerald-50 text-emerald-900' : aSigner ? 'border-orange-400 bg-gradient-to-r from-orange-100 to-amber-50 text-orange-900 ring-2 ring-orange-300' : 'border-slate-200 bg-slate-50 text-slate-800'}
          texte={signe ? `Signé le ${dateFr(r.signe_le)}` : aSigner ? `À signer : envoyé le ${dateFr(r.envoye_le)}. Lisez-le, cochez la phrase d'acceptation et signez.` : 'À lire avant votre entrée en formation'}>
          {consulter}
          {aSigner && (
            <button type="button" onClick={() => setOuvert(true)} data-testid="docs-reglement-signer"
              className={`${BTN} bg-orange-500 text-white hover:bg-orange-600`}><PenLine className="h-3.5 w-3.5" /> Lire et signer</button>
          )}
          {signe && (
            <button type="button" onClick={() => ouvrirPdf(`/reglement-interieur/signe/${user.user_id}`, 'Reglement_interieur_signe.pdf', 'download')} data-testid="reglement-telecharger-signe"
              className={`${BTN} bg-white text-emerald-700 ring-1 ring-emerald-200 hover:bg-emerald-100`}><Download className="h-3.5 w-3.5" /> Mon règlement signé</button>
          )}
        </Tuile>
      </div>
      {ouvert && <SignerReglementDialog ouvert={ouvert} onFermer={() => setOuvert(false)} r={r} uid={user.user_id} onSigne={() => { setOuvert(false); charger(); }} />}
    </section>
  );
};
